<template lang="html">
    <div id="page__printers" class="center-panel">
        <md-content md-theme="white" v-loader-overlay="progress">
            <sort-table
                v-model="printers" v-bind:columns="tableColumns" v-bind:per-page="perPage" v-bind:total="printersAmount" 
                v-on:create="addPrinter" v-on:refresh="getPrinters" link table-id="printers"
            >
                <div
                    v-if="scope.item.status" slot="status" slot-scope="scope" class="printer-status"
                    v-bind:style="('color: ' + ((scope.item.status.color) ? scope.item.status.color : '#000') + ';')"
                >
                    <span>{{scope.item.status.name}}</span>
                </div>

                <div slot="stock" slot-scope="scope" class="printer-stock">
                    <span>{{ (scope.item.stock && scope.item.stock.name) ? scope.item.stock.name : 'Не установлен' }}</span>
                </div>

                <template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" v-on:click.stop.prevent="onRemove(scope.item.id)" danger-light rounded></z-icon-button>
                </template>
            </sort-table>
        </md-content>
    </div>
</template>
<script>
    import StockMenu   from './stock-menu.vue';
    import SortTable   from "@/components/SortTable";
    import ZIconButton from '@/components/ZIconButton.vue';
    export default {
        components: {StockMenu, SortTable, ZIconButton},
        data() {
        return {
                tableColumns: [
                    { label: 'Название', field: 'name',       sortable: true },
                    { label: 'IP',       field: 'ip',         sortable: true },
                    { label: 'Порт',     field: 'port',         sortable: true },
                    { label: 'Склад',    field: 'stock', sortable: true},
                    { label: 'Статус',   field: 'status',     sortable: true },
                    { label: '',         field: 'actions'},
                ],
                title: 'Принтеры',
                removeDialog: false,
                printerIdToDelete: null,
                perPage: 50
            }
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['get-printers-list'];
            },
            /**
             * Объект с флагами загрузки
             */        
            progressObj() {
                return this.$store.state.progressObj;
            },
            /**
             * Список принтеров
             */            
            printers() {
                return this.$store.state.stock.printers.map(printer => {
                    printer.routerLink = { name: 'Printer', params: {id: printer.id} };
                    return printer;
                });        
            },
            /**
             * Количество принтеров
             */            
            printersAmount() {
                return this.$store.state.stock.printers_amount
            }
        },
        watch: {
            '$route.name'(name) {
                if (name == 'Printers') this.init();
            }
        },
        created() {
            this.init();
            this.getPrinters();
        },
        methods: {
            /**
            * Инициализация компонента
            */
            init() {
                this.$store.commit('setTitle', 'Принтеры');
            },
            /**
             * Добавление принтера
             */
            addPrinter() {
                this.$router.push({ name: 'Printer', params: {id: 'new'} });
            },
            /**
             * Вытаскивает фильтр из URL и форматирует его в коррктный вид для запроса, в формате:
             * {model: [['field', 'condition', 'value'], 'and|or', ['field', 'condition', 'value']]}
             */            
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return null;
                let filter = Object.assign({}, JSON.parse(this.$route.query.filter)), model = [];

                if (filter.search) model = [['ip',   '%', filter.search], 'or', ['name', '%', filter.search]];

                if (filter.stock_id) {
                    if (model.length) model.push('and');
                    model.push(['stock_id', '=', filter.stock_id]);
                }

                return {model: model};
            },
            /**
             * Получение списка принтеров
             */            
            getPrinters(page, count, orderBy, orderType) { //получение всех складов
                this.$store.commit('showProgressBar', 'get-printers-list');
                this.$store.dispatch('stock/getPrinters', {
                    page: page,
                    count:count,
                    order_by:   orderBy,
                    order_type: orderType,
                    filter: this.resolveQueryFilter()
                }).finally(() => this.$store.commit('hideProgressBar', 'get-printers-list'));
            },
            /**
             * Модальное окно с подтверждением удаления
             */            
            onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении записи?', 'Действие необратимо!',
                    () => this.remove(id)
                );
            },
            /**
             * Удаление принтера
             */            
            remove(id) {
                this.$store.commit('showProgressBar', 'get-printers-list');
                this.$store.dispatch('stock/removePrinter', id)
                    .then(() => this.$root.$emit('refresh-table', 'printers'))
                    .finally(() => this.$store.commit('hideProgressBar', 'get-printers-list'));
            }
        }
    }
</script>
<style lang="sass"></style>


// WEBPACK FOOTER //
// Printers.vue?25a01b36